import { DataTable, Metric } from "@odingard/design-system";
import { EmptyState, ErrorState, LoadingState } from "@odingard/design-system";
import type { UsageSummary } from "@odingard/sdk-client";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { api } from "../../lib/api";

const LABELS: Record<string, string> = {
  "contract.ingested": "Contracts ingested",
  "extraction.run": "Extractions run",
  "qa.query": "Ask Your Contracts queries",
  "clause.analyzed": "Clauses analyzed",
};

export function Usage() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(() => api.usage(orgId), [orgId]);

  const cols = [
    { key: "cap", header: "Capability", render: (r: UsageSummary) => LABELS[r.capabilityKey] ?? r.capabilityKey },
    { key: "qty", header: "Quantity", render: (r: UsageSummary) => r.totalQuantity.toLocaleString() },
    { key: "records", header: "Metered events", render: (r: UsageSummary) => r.recordCount.toLocaleString() },
  ];

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Usage</h1>
          <p>Metered activity for the current billing period.</p>
        </div>
      </div>
      {state.loading && <LoadingState />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {state.data && (
        <>
          <div className="metric-grid">
            {state.data.usage.slice(0, 4).map((u) => (
              <div className="metric-card" key={u.capabilityKey}>
                <Metric value={u.totalQuantity.toLocaleString()} label={LABELS[u.capabilityKey] ?? u.capabilityKey} />
              </div>
            ))}
          </div>
          {state.data.usage.length === 0 ? (
            <EmptyState icon="📊" title="No usage yet" description="Usage will appear as your team uses Contract AI." />
          ) : (
            <DataTable columns={cols} rows={state.data.usage.map((u) => ({ id: u.capabilityKey, ...u }))} caption="Usage summary" />
          )}
        </>
      )}
    </>
  );
}
